<template>
  <div class="cblog-cont">
    <blog-content-pages :per-page="12"/>
  </div>

</template>

<script>
import BlogContentPages from './components/BlogContentPages'
import LiveCitiesList from './components/LiveCitiesList'
export default {
  name: 'CompanyBlog',
  components: {
    BlogContentPages,
    LiveCitiesList
  },
  metaInfo () {
    return {
      title: 'Explore the World of Turkish Cuisine: Insights, Recipes, and More',
      titleTemplate: '%s',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Delve into the vibrant world of Turkish cuisine on our blog. Discover mouthwatering recipes, insightful articles, and fascinating stories that celebrate the rich flavors and traditions of Turkish food from various restaurants across the globe.'
        }
      ]
    }
  },
  mounted () {
    this.$store.dispatch('api/setSelectedCity', 'Blogs')
  },
  methods: {
  }
}
</script>

